import logo1999 from "../../assets/img/ple/backlash/1999.png";
import logo2000 from "../../assets/img/ple/backlash/2000.png";
import logo2001 from "../../assets/img/ple/backlash/2001.png";
import logo2002 from "../../assets/img/ple/backlash/2002.png";
import logo2003_2004 from "../../assets/img/ple/backlash/2003-2004.png";
import logo2005 from "../../assets/img/ple/backlash/2005.png";
import logo2006 from "../../assets/img/ple/backlash/2006.png";
import logo2007 from "../../assets/img/ple/backlash/2007.png";
import logo2008 from "../../assets/img/ple/backlash/2008.png";
import logo2009 from "../../assets/img/ple/backlash/2009.png";
import logo2016_2017 from "../../assets/img/ple/backlash/2016-2017.png";
import logo2018 from "../../assets/img/ple/backlash/2018.png";
import logo2020 from "../../assets/img/ple/backlash/2020.png";
import logo2021 from "../../assets/img/ple/backlash/2021.png";
import logo2022 from "../../assets/img/ple/backlash/2022.png";
import logo2023 from "../../assets/img/ple/backlash/2023.png";
import logo2024 from "../../assets/img/ple/backlash/2024.png";
import logo2025 from "../../assets/img/ple/backlash/2025.png";
import logo2026 from "../../assets/img/ple/backlash/2026.png";

export const backlashDetail = {
  id: "backlash",
  title: "Backlash",
  subtitle: "Explore the event editions in a dedicated event view.",
  tabs: [
    {
      id: "logos",
      label: "Editions",
      variant: "backlash",
      items: [
        {
          id: "backlash-1999",
          title: "Backlash",
          description: "In Your House 1999",
          imgUrl: logo1999,
        },
        {
          id: "backlash-2000",
          title: "Backlash",
          description: "2000",
          imgUrl: logo2000,
        },
        {
          id: "backlash-2001",
          title: "Backlash",
          description: "2001",
          imgUrl: logo2001,
        },
        {
          id: "backlash-2002",
          title: "Backlash",
          description: "One Man's Journey to Stand Alone 2002",
          imgUrl: logo2002,
        },
        {
          id: "backlash-2003",
          title: "Backlash",
          description: "2003 - 2004",
          imgUrl: logo2003_2004,
        },
        {
          id: "backlash-2005",
          title: "Backlash",
          description: "2005",
          imgUrl: logo2005,
        },
        {
          id: "backlash-2006",
          title: "Backlash",
          description: "Long Live The King 2006",
          imgUrl: logo2006,
        },
        {
          id: "backlash-2007",
          title: "Backlash",
          description: "2007",
          imgUrl: logo2007,
        },
        {
          id: "backlash-2008",
          title: "Backlash",
          description: "Every Action Deserves a Fierce and Aggressive Reaction 2008",
          imgUrl: logo2008,
        },
        {
          id: "backlash-2009",
          title: "Backlash",
          description: "2009",
          imgUrl: logo2009,
        },
        {
          id: "backlash-2016",
          title: "Backlash",
          description: "2016 - 2017",
          imgUrl: logo2016_2017,
        },
        {
          id: "backlash-2018",
          title: "Backlash",
          description: "Raw and SmackDown Together For The Price of One 2018",
          imgUrl: logo2018,
        },
        {
          id: "backlash-2020",
          title: "Backlash",
          description: "The Greatest Wrestling Match Ever 2020",
          imgUrl: logo2020,
        },
        {
          id: "backlash-2021",
          title: "WrestleMania Backlash",
          description: "2021",
          imgUrl: logo2021,
        },
        {
          id: "backlash-2022",
          title: "WrestleMania Backlash",
          description: "2022",
          imgUrl: logo2022,
        },
        {
          id: "backlash-2023",
          title: "Backlash",
          description: "2023",
          imgUrl: logo2023,
        },
        {
          id: "backlash-2024",
          title: "Backlash",
          description: "Nightmares Do Come True 2024",
          imgUrl: logo2024,
        },
        {
          id: "backlash-2025",
          title: "Backlash",
          description: "One Last Time 2025",
          imgUrl: logo2025,
        },
        {
          id: "backlash-2026",
          title: "Backlash",
          description: "Tampa 2026",
          imgUrl: logo2026,
        },
      ],
    },
  ],
};
